export const CHASE = {
    label: 'Chase',
    value: 'CHASE'
}